export default __webpack_public_path__ + "static/media/uploadIcon.629a166a.svg";